import React from 'react';
import { getRiskLevel } from '../../utils/securityLogic';

const LIKELIHOOD = ['Low', 'Med', 'High'];
const IMPACT = ['Low', 'Med', 'High'];

const ThreatMatrix = ({ domains }) => {
  const placed = domains.map(d => {
    const score = d.score;
    let lIdx, iIdx;
    if (score >= 4.5) { lIdx = 0; iIdx = 0; }
    else if (score >= 3.5) { lIdx = 0; iIdx = 1; }
    else if (score >= 3.0) { lIdx = 1; iIdx = 1; }
    else if (score >= 2.0) { lIdx = 1; iIdx = 2; }
    else { lIdx = 2; iIdx = 2; }
    return { ...d, lIdx, iIdx };
  });

  const cellColor = (l, i) => {
    const risk = l + i;
    if (risk >= 4) return 'bg-red-100 border-red-200';
    if (risk === 3) return 'bg-orange-100 border-orange-200';
    if (risk === 2) return 'bg-yellow-100 border-yellow-200';
    return 'bg-green-100 border-green-200';
  };

  const ABBR = { 'Identity & Access': 'IAM', 'Endpoint & Network': 'EDR', 'Data Backup & Recovery': 'BCR', 'Email & Phishing Risk': 'EPR', 'Security Awareness & Policy': 'SAP', 'Compliance & Insurance': 'C&I' };

  return (
    <div className="bg-white border border-slate-100 rounded-xl p-5">
      <div className="text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-3">Threat Risk Matrix</div>
      <div className="flex gap-2">
        {/* Y-axis label */}
        <div className="flex flex-col justify-center items-center" style={{ width: 16 }}>
          <span className="text-[9px] text-slate-400 font-semibold uppercase tracking-widest"
            style={{ writingMode: 'vertical-rl', transform: 'rotate(180deg)' }}>Impact →</span>
        </div>
        <div className="flex-1">
          {/* Grid */}
          <div className="grid grid-cols-3 gap-1">
            {[2, 1, 0].map(i =>
              [0, 1, 2].map(l => {
                const inCell = placed.filter(d => d.lIdx === l && d.iIdx === i);
                return (
                  <div key={`${l}-${i}`}
                    className={`border rounded-lg h-16 flex flex-wrap gap-1 items-center justify-center p-1.5 ${cellColor(l, i)}`}>
                    {inCell.map(d => (
                      <span key={d.id} title={d.name}
                        className="text-[9px] font-black text-slate-700 bg-white/80 px-1.5 py-0.5 rounded shadow-sm border border-white">
                        {ABBR[d.name] || d.name.slice(0, 3).toUpperCase()}
                      </span>
                    ))}
                  </div>
                );
              })
            )}
          </div>
          {/* X-axis labels */}
          <div className="grid grid-cols-3 gap-1 mt-1">
            {LIKELIHOOD.map(l => (
              <div key={l} className="text-center text-[9px] text-slate-400 font-semibold">{l}</div>
            ))}
          </div>
          <div className="text-center text-[9px] text-slate-400 font-semibold uppercase tracking-widest mt-0.5">Likelihood →</div>
        </div>
      </div>
      {/* Legend */}
      <div className="mt-3 flex flex-wrap gap-2">
        {domains.map(d => (
          <div key={d.id} className="flex items-center gap-1">
            <span className="text-[9px] font-black text-slate-600 bg-slate-100 px-1.5 py-0.5 rounded">
              {ABBR[d.name] || d.name.slice(0, 3).toUpperCase()}
            </span>
            <span className="text-[9px] text-slate-400">{d.name.split(' ').slice(0, 2).join(' ')}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ThreatMatrix;